import {
  type CohortBuilderDefinitionLegacy,
  CohortBuilderItemChangedBy,
  CohortBuilderItemChangeStatusLegacy,
  type StudyPeriodRestrictionsLegacy,
} from '@verantos-dev/types-cohorts';

import { computeDiffForCohortBuilderItem } from '../computeDiffForCohortBuilderItem';

export const getFullCohortDslForStudyPeriodRestriction = (
  currentCohortDefinition: CohortBuilderDefinitionLegacy | undefined,
  nextStudyPeriodRestrictions: StudyPeriodRestrictionsLegacy,
  addChangeStatus = false
) => {
  const previousStudyPeriodRestrictions = currentCohortDefinition?.studyPeriodRestrictions;

  let _changeStatus: CohortBuilderItemChangeStatusLegacy | undefined;
  if (addChangeStatus && previousStudyPeriodRestrictions) {
    // if study period restrictions previously existed
    if (
      computeDiffForCohortBuilderItem(previousStudyPeriodRestrictions, nextStudyPeriodRestrictions)
    ) {
      // if study period restrictions previously existed and is different from current update
      if (
        previousStudyPeriodRestrictions.changeStatus === CohortBuilderItemChangeStatusLegacy.NEW
      ) {
        // if study period restrictions was new, then it's still new
        _changeStatus = CohortBuilderItemChangeStatusLegacy.NEW;
      } else {
        // study period restrictions is edited
        _changeStatus = CohortBuilderItemChangeStatusLegacy.EDITED;
      }
    } else {
      // if study period restrictions previously existed and is the same as current update, then it's unchanged
      _changeStatus = previousStudyPeriodRestrictions.changeStatus;
    }
  } else if (addChangeStatus) {
    // if no study period restrictions previously existed, then it's new
    _changeStatus = CohortBuilderItemChangeStatusLegacy.NEW;
  }

  const studyPeriodRestrictions: StudyPeriodRestrictionsLegacy | undefined =
    nextStudyPeriodRestrictions
      ? addChangeStatus
        ? {
            ...nextStudyPeriodRestrictions,
            changeStatus: _changeStatus,
            changedBy: CohortBuilderItemChangedBy.COHORT_BUILDER,
          }
        : nextStudyPeriodRestrictions
      : undefined;

  const cohortDefinition: CohortBuilderDefinitionLegacy = {
    studyPeriodRestrictions,
    subjectVariables: currentCohortDefinition?.subjectVariables ?? [],
    indexDate: currentCohortDefinition?.indexDate,
    simpleEvents: currentCohortDefinition?.simpleEvents ?? [],
    derivedEvents: currentCohortDefinition?.derivedEvents ?? [],
    // FEATURE FLAG: Preserve analytical variables fields when present
    // These fields come from backend when analytical_variables_in_cohort_builder is enabled
    // CLEANUP TODO: When removing the `analytical_variables_in_cohort_builder` feature flag, ensure these fields are always preserved
    analyticalVariables: currentCohortDefinition?.analyticalVariables,
    criteria: currentCohortDefinition?.criteria,
  };

  return {
    cohortDefinition,
  };
};
